import { render } from "./MovCaja.vue?vue&type=template&id=083b29dc&scoped=true"
import script from "./MovCaja.vue?vue&type=script&lang=js"
export * from "./MovCaja.vue?vue&type=script&lang=js"

import "./MovCaja.vue?vue&type=style&index=0&id=083b29dc&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\frontend_zapi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-083b29dc"]])

export default __exports__